export default __webpack_public_path__ + "static/media/bagan_organisasi.e5a8b4f2.jpeg";